import NewMethod from '~components/new-chat'

export default NewMethod
